'use client';

import { useSyncExternalStore } from 'react';
const subscribe = () => () => {};

/**
 * False while rendering on the server and while hydrating its HTML; true afterwards and for
 * renders that start in the browser. Gate output the server can't reproduce (the browser's time
 * zone or platform) on it so hydration never mismatches.
 */
export const useHasHydrated = () => {
  return useSyncExternalStore(subscribe, _temp, _temp2);
};
function _temp() {
  return true;
}
function _temp2() {
  return false;
}